import script from "./SessionParticipantsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionParticipantsList.vue?vue&type=script&setup=true&lang=js"

import "./SessionParticipantsList.vue?vue&type=style&index=0&id=1a47b773&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a47b773"]])

export default __exports__